import type { LinksType } from './link.enum'

export class Link {
    profileLinkId: string
    type: LinksType
    title: string
    url: string
    status: number
    createdAt: Date
    updatedAt: Date
    icon?: string
    companyId: string
}
